import Vue from 'vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'





Vue.use(AlertPlugin);

































const baseLocal = {

localSet(obj, key) {
let newObj = obj;
let str = JSON.stringify(newObj);
localStorage.setItem(key, str);
},
localGet(key) {
let str = localStorage.getItem(key);
return JSON.parse(str);
},
localClear(key) {
localStorage.removeItem(key);
},
getQueryString(name) {
let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
let r = window.location.search.substr(1).match(reg);
if (r != null) return decodeURI(r[2]);
return null;
}
};


export default {
baseLocal,

}



// WEBPACK FOOTER //
// ./src/assets/js/baseLocal.js